// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".season-card .Popup-container--down{top:100%}", "",{"version":3,"sources":["webpack://src/components/pages/seasons.scss"],"names":[],"mappings":"AAEE,oCACE,QAAA","sourcesContent":["// this style is necessary to ensure that the overlay doesn't push the horizontal width of the page.\n.season-card {\n  .Popup-container--down {\n    top: calc(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
